module.exports = __webpack_public_path__ + "static/media/file.b00bcfec.svg";